// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"364":"26518d5f","712":"bc2c2bce"}[chunkId] + ".chunk.js";
};